<template>
  <div class="bin-supply">
    <el-dialog
      width="640px"
      align="center"
      title="批量绑定「代采员」"
      :visible="visible"
      :before-close="closeBox"
    >
      <el-form :model="form">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="商家id（一行一个，最多1000个）" required>
              <el-input
                v-model="form.supply_ids"
                :rows="8"
                type="textarea"
                placeholder="一行一个id"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14" :style="{ marginTop: '40px' }">
            <el-form-item label="选择代采员" align="left">
              <el-select v-model="form.pg_member_id" placeholder="" filterable>
                <el-option
                  v-for="(item, index) in member"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeBox(0)">取 消</el-button>
        <el-button type="success" size="small" @click="submitData">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    supplyIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: true,
      form: { supply_ids: "" },
      member: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$http
        .post("/erp/Common/getPurchaseMember", { status: 1 })
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.member = result.data.data;
        })
        .catch(() => {});
    },
    submitData() {
      const { pg_member_id: pgMemberId, supply_ids: supplyIds } = this.form;

      // 校验是否有商家id
      if (supplyIds === "") {
        this.$message({
          showClose: true,
          message: "请输入商家ids~",
          type: "error",
        });
        return;
      }
      this.form.supply_ids = this.supplyIds;
      this.$http
        .post("/erp/Supply/SupplyBindPgMember", {
          pg_member_id: pgMemberId,
          supply_ids: supplyIds.trim().split("\n"),
        })
        .then((result) => {
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
            return;
          }
          this.$message.success("绑定成功");
          this.closeBox(true);
        })
        .catch(() => {});
    },
    closeBox(isNormal) {
      let _isNormal = isNormal;
      if (typeof isNormal === "function") {
        _isNormal = 0;
      }
      this.$emit("onCloseDialog", _isNormal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/supply/components/PgBindSupply.vue